import React from 'react';
import { Document, Page } from 'react-pdf';
import Pagination from '@material-ui/lab/Pagination';

function PDFViewer(props) {
  const [numPages, setPageNumber] = React.useState(1);
  const [totalPages, setTotalPages] = React.useState(1);
  // const pageNumber = 1;
  function onDocumentLoadSuccess({ numPages }) {
    // setPageNumber(numPages);
    setTotalPages(numPages);
  }

  const handleChange = (event, value) => {
    setPageNumber(value);
  };

  const handleError = (err) => {
    console.log(err);
    
  };
  

  const memoFile = React.useMemo(() => {
    const filePDF = {
        url: `/fop/file/${props.filePreview}`,
        httpHeaders: {
          'Authorization': `Bearer ${localStorage.jwtToken}`,
        },
        withCredentials: true,
      };

      return filePDF;
  }, [props.filePreview]);

  return (
    <div>
      <Pagination className="mb-2" shape="rounded" size="small" count={totalPages} color="primary" variant="outlined" page={numPages} onChange={handleChange} />
      <Document file={memoFile} onLoadSuccess={onDocumentLoadSuccess} onLoadError={handleError}>
        <Page pageNumber={numPages} style={{ width: '75%' }} />
      </Document>
    </div>
  );
}

export default PDFViewer;
